import { createStyles } from 'antd-style';
import { hoverBg1 } from 'constants/color';
import { drawerWidth } from 'store/constant';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      padding: 0px;
      flex: 0 0 ${drawerWidth}px;
      min-height: 100vh;
      max-height: 100vh;
      overflow: visible;
      position: unset;
      left: 0px;
      right: unset;
    `,
    wrap: css`
      height: 100%;
      margin-top: -0.1px;
      padding-top: 0.1px;
    `,
    menu: css`
      background-color: #fff;
      .ant-menu-item {
        margin: 4px 0;
      }
    `,
    menuContainer: css`
      max-height: calc(100% - 70px);
      /* padding: 12px; */
      overflow: auto;
      box-sizing: border-box;
    `,
    menuWrap: css``,
    title: css`
      font-size: 14px;
      font-weight: bold;
      margin-top: 10px;
      padding-left: 30px;
    `
  };
});

export const useMenuItemStyles = createStyles(({ token, css }, props: { isActive: boolean }) => {
  const { isActive } = props;
  return {
    menuItem: css`
      margin-top: 10px;
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 10px;
      padding-left: 26px;
      cursor: pointer;
      transition: all 0.2s;
      background-color: ${isActive ? hoverBg1 : '#fff'};
      color: ${isActive ? token.colorPrimary : 'rgba(0, 0, 0, 0.65)'};
      border-left: ${isActive ? `4px solid ${token.colorPrimary}` : '4px solid transparent'};
      &:hover {
        background-color: ${hoverBg1};
      }
      &:active {
        opacity: 0.9;
      }
    `,
    subMenuTitle: css`
      font-size: 14px;
      margin-left: 8px;
    `
  };
});
